import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";


const {ccclass, property} = cc._decorator;

@ccclass
export default class LocalMagicWashCard extends cc.Component {

    @property({type:cc.Node,displayName:"卡片layout"})
    cardLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"卡背layout"})
    cardBackLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"手指节点"})
    fingerNode:cc.Node = null;

    @property({type:cc.Node,displayName:"卡片节点"})
    cardNode:cc.Node = null;

    @property({type:cc.Node,displayName:"卡背节点"})
    cardBackNode:cc.Node = null;

    @property({type:cc.Node,displayName:"手节点"})
    handNode:cc.Node = null;

    excludeAry:string[] = [];

    onLoad(){
        // this.showAni();
        this.handNode.scale = 0.6;
        this.loadAni().then();
        cc.tween(this.handNode).to(0.5,{scale:1}).start();
    }

    /**
     * 展示动画
     */
    async showAni(){
        return new Promise<void>(async resolve =>{
            this.node.active = true;
            this.handNode.active = true;
            this.playSound(  );
            this.cardLayout.getComponent(cc.Layout).enabled = false;
            // this.cardBackLayout.getComponent(cc.Layout).enabled = false;
            await this.startAni();
            resolve();
        });
    }

    //播放声音
    playSound( index : number = 0 , circleCount : number = 3 ){
        if ( index == circleCount ) {
            //循环几次后停止
            return;
        }
        O1HD.getManagers().soundMgr.playSound("washCard", ()=>{
            this.playSound( ++index , circleCount );
        }
        , BUNDLE_SMALL_NAME.localMagic
        ).then();
    }


    /**
     * 加载动画
     */
    async loadAni(){
        //@ts-ignore
        let province = DC.getProvs().concat();
        province = data_control.randomSortArray(province);
        let name = "";
        province.forEach(element => {
            name = element._name;
            // console.log( this.excludeAry );
            if(!this.excludeAry.includes(name)){
                // console.log( name );
                let card:cc.Node = cc.instantiate(this.cardNode);
                let cardBack:cc.Node = cc.instantiate(this.cardBackNode);

                this.cardLayout.addChild(card);
                this.cardBackLayout.addChild(cardBack);

                card.opacity = 255;
                cardBack.opacity = 0;
            }
        });
        this.cardLayout.children.forEach((n:cc.Node,index:number)=>{
            let labelNode:cc.Node = n.getChildByName("provinceLb");
            let label:cc.Label = labelNode.getComponent(cc.Label);
            label.string = province[index]._name;
        });
    }

    onceTime:number = 0.1;

    /**
    * 开始动画
    */
    async startAni(){
        return new Promise<void>(resolve=>{
            this.cardLayout.children.forEach((n:cc.Node)=>{
                n.opacity = 150;
            });

            let length = this.cardLayout.childrenCount;
            let needTime:number = length * this.onceTime;
            let index:number = 0;
            cc.tween(this.handNode).to(needTime,{scale:1.3}).call( ()=>{
                this.hideAni();
                resolve();
            }).start();
            for(let i = length - 1; i>=0; i--){
                let cardNode:cc.Node = this.cardLayout.children[i];
                let cardBackNode:cc.Node = this.cardBackLayout.children[index];
                let detalTime:number = index*this.onceTime;
                index ++;
                cc.tween(cardNode).delay(detalTime).to(this.onceTime,{opacity:0}).call(()=>{
                    cardNode.active = false;
                    cardBackNode.opacity = 255;
                }).start();
            }
        })
    }

    /**
     *初始化动画
     */
    async initAni(){
        return new Promise<void>(resolve=>{
            this.cardLayout.children.forEach((n:cc.Node)=>{
                n.active = true;
                n.opacity = 255;
            });
            this.cardBackLayout.children.forEach((n:cc.Node)=>{
                n.opacity = 0;
            });
            cc.tween(this.handNode).to(0.5,{scale:1}).call(resolve).start();
        });
    }

    /**
     * 更改每张牌动画需要的时间
     */
    changeOnceTime(time:number){
        this.onceTime = time;
    }

    /**
     * 重新开始动画
     */
    async restartAni(){
        await this.initAni();
        this.playSound( 0 ,4 );
        return this.startAni();
    }

    /**
     * 隐藏动画
     */
    async hideAni(){
        return new Promise<void>(resolve=>{
            cc.tween(this.handNode).to(0.5,{scale:1}).call(resolve).start();
        });
    }

}
